export const pipe = (value: any) => ({
  value,
  through: (fn: Function, ...args: any[]) => pipe(fn(value, ...args)),
});
